import auth from './auth';
import scholars from './scholars';
import users from './users';
import spinner from './spinner';
import events from './events';
import digitalResources from './digital-resources';
import signinResources from './signin-resources';
import anetaPack from './aneta-pack';
import appState from './app-state';
import payments from './payments';

const rootReducer = {
  auth,
  scholars,
  users,
  spinner,
  events,
  digitalResources,
  signinResources,
  anetaPack,
  appState,
  payments,
};
export default rootReducer;
